module.exports = __webpack_public_path__ + "public/img/hug.5a64d081.png";